/**
 * 上游错误码 ⇒ 用户友好提示语 翻译表
 *
 * 与 PRD §4.2 一致：前端响应拦截器命中以下 code 时统一翻译并气泡提示。
 * 维护原则:
 *   - key 来自后端 ApiEnvelope.upstreamCode（优先）或 ApiEnvelope.code
 *   - value 必须是面向最终用户的中文白话文，避免暴露上游原始英文
 */
export const ERROR_CODE_DICT: Record<string, string> = {
  // —— 通用业务 ——
  AUTH_REQUIRED: '登录已失效，请重新登录',
  PERMISSION_DENIED: '当前账号无权限执行该操作',
  INVALID_PARAMS: '提交的参数不符合规范，请检查后重试',
  RATE_LIMITED: '操作过于频繁，请稍后再试',

  // —— 母账户 / 资金 ——
  INSUFFICIENT_BALANCE: '母账户余额不足，请先充值或减少限额',
  ORDER_DUPLICATED: '检测到重复流水号，已为您拦截',

  // —— 卡片相关 ——
  CARD_NOT_FOUND: '未找到该虚拟卡，可能已被销户',
  CARD_FROZEN: '该卡已被风控冻结，操作已拒绝',
  CARD_NOT_ACTIVE: '卡片尚未激活，无法发起此操作',
  CARD_LIMIT_EXCEEDED: '已超出该卡段单笔最高额度',

  // —— 持卡人 ——
  HOLDER_KYC_REJECTED: '持卡人 KYC 资料未通过上游风控审核',

  // —— 上游通道 ——
  UPSTREAM_RISK_REJECTED: '上游风控拒绝本次开卡 / 充值，请稍后重试或联系客服',
  UPSTREAM_TIMEOUT: '上游通道超时，请稍后查看处理结果',
  UPSTREAM_UNAVAILABLE: '上游通道暂不可用，请稍后重试',
};

export function translateErrorCode(code?: string, fallback?: string): string {
  if (!code) return fallback || '请求失败，请稍后重试';
  return ERROR_CODE_DICT[code] || fallback || `请求失败 (${code})`;
}
